import { Loader } from '@googlemaps/js-api-loader'
import { cutsomControls } from '../map/controls'
import { leaseSvg, parkingSvg } from '../map/markerIcons'
import { parseSvgString } from '../map/parseSvgString'
import { GOOGLE_MAPS_ID, GOOGLE_MAPS_KEY } from '../map/constants'

const loader = new Loader({
  apiKey: GOOGLE_MAPS_KEY,
  version: 'weekly',
  libraries: ['marker'],
})

type location = google.maps.LatLngLiteral & { id?: string }

type Props = {
  leaseLocation: location
  parkingLocations: google.maps.LatLngLiteral[]
  mapElement: HTMLElement
  extraMapOptions?: google.maps.MapOptions
}

const initLeaseMap = ({
  leaseLocation,
  parkingLocations,
  mapElement,
  extraMapOptions,
}: Props): Promise<void> =>
  loader
    .importLibrary('marker')
    .then(({ AdvancedMarkerElement }) => {
      const mapOptions = {
        disableDefaultUI: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
        center: leaseLocation,
        zoom: 14,
        minZoom: 3,
        mapId: GOOGLE_MAPS_ID,
        ...extraMapOptions,
      } as google.maps.MapOptions

      let leaseMap = new google.maps.Map(mapElement, mapOptions)

      // Add custom controls.
      cutsomControls(leaseMap)

      const marker = new AdvancedMarkerElement({
        map: leaseMap,
        position: leaseLocation,
        title: '',
        content: parseSvgString(leaseSvg),
        zIndex: 2,
      })

      // Add parking markers to the map
      parkingLocations.map((position) => {
        const parkingMarker = new AdvancedMarkerElement({
          map: leaseMap,
          position,
          title: '',
          content: parseSvgString(parkingSvg),
          zIndex: 1,
        })
      })
    })
    .catch((err) => console.error(err))

window.initLeaseMap = initLeaseMap
